import { v4 as uuidv4 } from 'uuid';

import {
    AD_CONNECTOR_TYPE,
    DEFAULT_VENDOR_TO_ID,
    SHARED_KEY,
    SSO_APP_SOURCE_TYPE
} from '@silverfort-nodelibs/common/utils/consts';
import {
    addFieldsToArray,
    buildField,
    getFieldValueIfDirty,
    isFieldDirty,
    removeFromArray,
    updateTabField,
    updateTabFieldArray
} from '../../common/utils';
import { SUBCATEGORIES } from '../../common/categories';
import * as actions from './integrationsActions';
import { commonActionsReducer } from '../../common/actions';
import {
    ADFS_APP_FIELDS,
    AZURE_AD_ENTERPRISE_APPLICATIONS_FIELDS,
    AZURE_CONNECTOR_FIELDS,
    AZURE_CONNECTORS_FIELDS,
    IS_NEW_FIELD,
    NAMING_CONVENTIONS_FIELDS,
    NEW_AZURE_CONNECTOR_FIELDS,
    OKTA_CONNECTOR_FIELDS,
    OKTA_CONNECTORS_FIELDS,
    PINGFED_APP_FIELDS,
    SSO_APP_VENDORS_FIELDS,
    SSO_APPLICATION_FIELDS
} from '../../common/fields';
import { LOGIN_HINT_MEANINGFUL_VALUES } from '../../components/SSOApps/consts';

const { ADFS_FEDERATED_APPS, PING_FEDERATED_APPS, AZURE_CONNECTORS, NEW_AZURE_CONNECTORS, OKTA_CONNECTORS, SSO_APPS } =
    SUBCATEGORIES;
const { AZURE_AD_CONNECTOR, AZURE_REDIRECT_URI, NEW_AZURE_AD_CONNECTOR, AZURE_AD_NAMING_CONVENTIONS } =
    AZURE_CONNECTORS_FIELDS;
const { OKTA_REDIRECT_URI, OKTA_BRIDGE_ENABLED, OKTA_BRIDGE_CONNECTOR } = OKTA_CONNECTORS_FIELDS;
const { ENTRA_ID, OKTA, PING_FEDERATE, ONE_LOGIN, CYBER_ARK, CUSTOM_VENDOR, THALES_STA, BEYOND_IDENTITY } = SSO_APP_VENDORS_FIELDS;
const { CONDITION, CONDITION_TYPE } = NAMING_CONVENTIONS_FIELDS;
const { VENDOR_NAME } = SSO_APPLICATION_FIELDS.CUSTOM_VENDOR;

export const fieldsReducer = (state, action) => {
    switch (action.type) {
        case actions.UPDATE_ADFS_APP:
            return updateTabFieldArray(
                state,
                ADFS_FEDERATED_APPS.ID,
                ADFS_FEDERATED_APPS.ID,
                action.payload.index,
                action.payload.arrFieldId,
                action.payload.value
            );
        case actions.ADD_ADFS_APP:
            return addFieldsToArray(state, ADFS_FEDERATED_APPS.ID, ADFS_FEDERATED_APPS.ID, newADFSApp());
        case actions.ADD_MULTIPLE_ADFS_APPS:
            return addMultipleAppsAction(state, action, ADFS_FEDERATED_APPS.ID, ADFS_FEDERATED_APPS.ID, mapADFSFields);
        case actions.REMOVE_ADFS_APP:
            return removeFromArray(state, ADFS_FEDERATED_APPS.ID, ADFS_FEDERATED_APPS.ID, action.payload);
        case actions.UPDATE_PINGFED_APP:
            return updateTabFieldArray(
                state,
                PING_FEDERATED_APPS.ID,
                PING_FEDERATED_APPS.ID,
                action.payload.index,
                action.payload.arrFieldId,
                action.payload.value
            );
        case actions.ADD_PINGFED_APP:
            return addFieldsToArray(state, PING_FEDERATED_APPS.ID, PING_FEDERATED_APPS.ID, newPingFedApp());
        case actions.ADD_MULTIPLE_PINGFED_APPS:
            return addMultipleAppsAction(
                state,
                action,
                PING_FEDERATED_APPS.ID,
                PING_FEDERATED_APPS.ID,
                mapPingFedFields
            );
        case actions.REMOVE_PINGFED_APP:
            return removeFromArray(state, PING_FEDERATED_APPS.ID, PING_FEDERATED_APPS.ID, action.payload);
        case actions.ADD_AZURE_CONNECTOR:
            return addFieldsToArray(state, AZURE_CONNECTORS.ID, AZURE_AD_CONNECTOR.ID, newAzureApp());
        case actions.REMOVE_AZURE_CONNECTOR:
            return removeFromArray(state, AZURE_CONNECTORS.ID, AZURE_AD_CONNECTOR.ID, action.payload);
        case actions.ADD_NEW_AZURE_CONNECTOR:
            return addFieldsToArray(state, NEW_AZURE_CONNECTORS.ID, NEW_AZURE_AD_CONNECTOR.ID, newAzureConnector());
        case actions.REMOVE_NEW_AZURE_CONNECTOR:
            return removeFromArray(state, NEW_AZURE_CONNECTORS.ID, NEW_AZURE_AD_CONNECTOR.ID, action.payload);
        case actions.UPDATE_CONNECTOR:
            return updateTabFieldArray(
                state,
                action.payload.tabKey,
                action.payload.fieldId,
                action.payload.index,
                action.payload.arrFieldId,
                action.payload.value
            );
        case actions.UPDATE_CONNECTORS_FIELDS:
            return updateTabField(state, action.payload.tabKey, action.payload.fieldId, action.payload.value);
        case actions.ADD_NAMING_CONVENTION:
            return addFieldsToArray(
                state,
                action.payload.tabKey,
                AZURE_AD_NAMING_CONVENTIONS.ID,
                mapNamingConventions(
                    [
                        {
                            conditionString: '',
                            conditionType: 1
                        }
                    ],
                    true
                )[0]
            );
        case actions.REMOVE_NAMING_CONVENTION:
            return removeFromArray(state, action.payload.tabKey, AZURE_AD_NAMING_CONVENTIONS.ID, action.payload.index);
        case actions.ADD_SSO_APP: {
            let newFieldData;
            const { showLoginHint } = state[SSO_APPS.ID][SHARED_KEY];
            switch (action.payload.arrFieldId) {
                case DEFAULT_VENDOR_TO_ID.AZURE:
                    newFieldData = newSSOEntraIdApp(showLoginHint);
                    break;
                case DEFAULT_VENDOR_TO_ID.OKTA:
                    newFieldData = newSSOOktaApp(showLoginHint);
                    break;
                case DEFAULT_VENDOR_TO_ID.PING_FEDERATE:
                    newFieldData = newSSOPingFederateApp(showLoginHint);
                    break;
                case DEFAULT_VENDOR_TO_ID.ONE_LOGIN:
                    newFieldData = newSSOOneLoginApp(showLoginHint);
                    break;
                case DEFAULT_VENDOR_TO_ID.CYBER_ARK:
                    newFieldData = newSSOCyberArkApp(showLoginHint);
                    break;
                case DEFAULT_VENDOR_TO_ID.THALES_STA:
                    newFieldData = newSSOThalesSTAApp(showLoginHint);
                    break;
                case DEFAULT_VENDOR_TO_ID.BEYOND_IDENTITY:
                    newFieldData = newSSOBeyondIdentityApp(showLoginHint);
                    break;
                default:
                    newFieldData = newSSOApp(action.payload.arrFieldId, action.payload.vendorName);
                    break;
            }
            return addFieldsToArray(state, action.payload.tabKey, action.payload.arrFieldId, newFieldData);
        }
        case actions.REMOVE_SSO_APP: {
            return removeFromArray(state, action.payload.tabKey, action.payload.arrFieldId, action.payload.index);
        }
        case actions.UPDATE_SSO_APP: {
            return updateTabFieldArray(
                state,
                action.payload.tabKey,
                action.payload.fieldId,
                action.payload.index,
                action.payload.arrFieldId,
                action.payload.value
            );
        }

        case actions.ADD_SSO_VENDOR: {
            const newVendorId = uuidv4();
            const newSSOVendor = { [newVendorId]: { id: newVendorId, name: '', signInImageFilename: '' } };
            const newSSOVendorList = {
                ...state[SSO_APPS.ID][SHARED_KEY],
                ssoVendors: { ...state[SSO_APPS.ID][SHARED_KEY].ssoVendors, ...newSSOVendor }
            };
            const { showLoginHint } = state[SSO_APPS.ID][SHARED_KEY];
            const newSSOField = {
                [newVendorId]: buildField(CUSTOM_VENDOR, [newSSOApp(newVendorId, '', showLoginHint)])
            };

            const newSSOFieldList = { ...state[SSO_APPS.ID].fields, ...newSSOField };

            return {
                ...state,
                [SSO_APPS.ID]: {
                    ...state[SSO_APPS.ID],
                    fields: newSSOFieldList,
                    [SHARED_KEY]: newSSOVendorList
                }
            };
        }
        case actions.UPDATE_SSO_VENDOR: {
            let updatedSSOVendorList = { ...state[SSO_APPS.ID][SHARED_KEY] };
            if (action.payload.arrFieldId === VENDOR_NAME.ID) {
                const updatedSSOVendor = {
                    [action.payload.fieldId]: {
                        id: action.payload.fieldId,
                        name: action.payload.value,
                        signInImageFilename: ''
                    }
                };
                updatedSSOVendorList = {
                    ...state[SSO_APPS.ID][SHARED_KEY],
                    ssoVendors: { ...state[SSO_APPS.ID][SHARED_KEY].ssoVendors, ...updatedSSOVendor }
                };
            }

            const updatedState = updateTabFieldArray(
                state,
                action.payload.tabKey,
                action.payload.fieldId,
                action.payload.index,
                action.payload.arrFieldId,
                action.payload.value
            );

            return {
                ...updatedState,
                [SSO_APPS.ID]: {
                    ...updatedState[SSO_APPS.ID],
                    [SHARED_KEY]: updatedSSOVendorList
                }
            };
        }
        default:
            return commonActionsReducer(state, action, initFieldsState);
    }
};

export const initFieldsState = ({ settings }) => {
    const fields = {};
    fields[ADFS_FEDERATED_APPS.ID] = {
        id: ADFS_FEDERATED_APPS.ID,
        name: ADFS_FEDERATED_APPS.NAME,
        fields: {
            [ADFS_FEDERATED_APPS.ID]: buildField(ADFS_FEDERATED_APPS, mapADFSFields(settings.RelyingParties))
        },
        validators: {
            uniqueIdentifier: [ADFS_FEDERATED_APPS.ID, ADFS_APP_FIELDS.IDENTIFIER.ID]
        }
    };
    fields[PING_FEDERATED_APPS.ID] = {
        id: PING_FEDERATED_APPS.ID,
        name: PING_FEDERATED_APPS.NAME,
        fields: {
            [PING_FEDERATED_APPS.ID]: buildField(PING_FEDERATED_APPS, mapPingFedFields(settings.RelyingPartiesPingFed))
        },
        validators: {
            uniqueIdentifier: [PING_FEDERATED_APPS.ID, PINGFED_APP_FIELDS.IDENTIFIER.ID]
        }
    };

    if (!settings.AADApplications) {
        fields[NEW_AZURE_CONNECTORS.ID] = {
            id: NEW_AZURE_CONNECTORS.ID,
            name: NEW_AZURE_CONNECTORS.NAME,
            fields: {
                [NEW_AZURE_AD_CONNECTOR.ID]: buildField(
                    NEW_AZURE_AD_CONNECTOR,
                    mapNewAzureADConnectorFields(settings.AADConnectors)
                ),
                [AZURE_AD_NAMING_CONVENTIONS.ID]: buildField(
                    AZURE_AD_NAMING_CONVENTIONS,
                    mapNamingConventions(settings.AzureAdUserNamingConventions)
                )
            },
            validators: {
                uniqueIdentifier: [NEW_AZURE_AD_CONNECTOR.ID, NEW_AZURE_CONNECTOR_FIELDS.TENANT_ID.ID]
            }
        };
    } else {
        fields[AZURE_CONNECTORS.ID] = {
            id: AZURE_CONNECTORS.ID,
            name: AZURE_CONNECTORS.NAME,
            fields: {
                [AZURE_AD_CONNECTOR.ID]: buildField(
                    AZURE_AD_CONNECTOR,
                    mapAzureADConnectorFields(settings.AADApplications, AD_CONNECTOR_TYPE.APPLICATION)
                ),
                [AZURE_REDIRECT_URI.ID]: buildField(AZURE_REDIRECT_URI, settings.AADApplicationsRedirectURI),
                [AZURE_AD_NAMING_CONVENTIONS.ID]: buildField(
                    AZURE_AD_NAMING_CONVENTIONS,
                    mapNamingConventions(settings.AzureAdUserNamingConventions)
                )
            },
            validators: {
                uniqueIdentifier: [AZURE_AD_CONNECTOR.ID, AZURE_CONNECTOR_FIELDS.APPLICATION_ID.ID]
            }
        };
    }

    fields[OKTA_CONNECTORS.ID] = {
        id: OKTA_CONNECTORS.ID,
        name: OKTA_CONNECTORS.NAME,
        fields: {
            [OKTA_REDIRECT_URI.ID]: buildField(OKTA_REDIRECT_URI, settings.OktaRedirectURI),
            [OKTA_BRIDGE_ENABLED.ID]: buildField(OKTA_BRIDGE_ENABLED, settings.OktaBridgeEnabled),
            [OKTA_BRIDGE_CONNECTOR.ID]: buildField(
                OKTA_BRIDGE_CONNECTOR,
                mapOktaConnectorFields(settings.OktaApplications)
            )
        },
        validators: {}
    };

    const ssoApplications = Object.values(settings.SSOApplications).filter(
        (ssoApp) => ssoApp.source === SSO_APP_SOURCE_TYPE.INTEGRATIONS
    );
    const ssoVendors = settings.SSOVendors;
    const fieldsData = {};
    const showLoginHint = settings.bridgeSSOHintEnabled;

    for (const ssoVendor in ssoVendors) {
        const currentVendor = +ssoVendor;

        let vendorField, ssoApplicationsFields;
        switch (currentVendor) {
            case DEFAULT_VENDOR_TO_ID.AZURE:
                [vendorField, ssoApplicationsFields] = [ENTRA_ID, SSO_APPLICATION_FIELDS.ENTRA_ID];
                break;
            case DEFAULT_VENDOR_TO_ID.OKTA:
                [vendorField, ssoApplicationsFields] = [OKTA, SSO_APPLICATION_FIELDS.OKTA];
                break;
            case DEFAULT_VENDOR_TO_ID.PING_FEDERATE:
                [vendorField, ssoApplicationsFields] = [PING_FEDERATE, SSO_APPLICATION_FIELDS.PING_FEDERATE];
                break;
            case DEFAULT_VENDOR_TO_ID.ONE_LOGIN:
                [vendorField, ssoApplicationsFields] = [ONE_LOGIN, SSO_APPLICATION_FIELDS.ONE_LOGIN];
                break;
            case DEFAULT_VENDOR_TO_ID.CYBER_ARK:
                [vendorField, ssoApplicationsFields] = [CYBER_ARK, SSO_APPLICATION_FIELDS.CYBER_ARK];
                break;
            case DEFAULT_VENDOR_TO_ID.THALES_STA:
                [vendorField, ssoApplicationsFields] = [THALES_STA, SSO_APPLICATION_FIELDS.THALES_STA];
                break;
            case DEFAULT_VENDOR_TO_ID.BEYOND_IDENTITY:
                [vendorField, ssoApplicationsFields] = [BEYOND_IDENTITY, SSO_APPLICATION_FIELDS.BEYOND_IDENTITY];
                break;
            default:
                [vendorField, ssoApplicationsFields] = [CUSTOM_VENDOR, SSO_APPLICATION_FIELDS.CUSTOM_VENDOR];
                break;
        }

        const ssoVendorApplications = ssoApplications.filter((app) => app.vendorId === currentVendor);
        const showLoginHint = settings.bridgeSSOHintEnabled;
        fieldsData[currentVendor] = buildField(
            vendorField,
            mapSSOApplicationsFields(ssoVendors, ssoVendorApplications, ssoApplicationsFields, showLoginHint)
        );
    }

    fields[SSO_APPS.ID] = {
        id: SSO_APPS.ID,
        name: SSO_APPS.NAME,
        fields: fieldsData,
        [SHARED_KEY]: {
            ssoVendors,
            showLoginHint
        },
        validators: {}
    };

    return fields;
};

export const mapToSettings = (saveAll, selectedTab, fields) => {
    const newSettings = {};
    if (saveAll || selectedTab === ADFS_FEDERATED_APPS.ID) {
        const adfsFields = fields[ADFS_FEDERATED_APPS.ID].fields;
        newSettings.RelyingParties = getFieldValueIfDirty(
            adfsFields[ADFS_FEDERATED_APPS.ID],
            mapFieldsToADFS(adfsFields[ADFS_FEDERATED_APPS.ID].value)
        );
    }
    if (saveAll || selectedTab === PING_FEDERATED_APPS.ID) {
        const pingFedFields = fields[PING_FEDERATED_APPS.ID].fields;
        newSettings.RelyingPartiesPingFed = getFieldValueIfDirty(
            pingFedFields[PING_FEDERATED_APPS.ID],
            mapFieldsToPingFed(pingFedFields[PING_FEDERATED_APPS.ID].value)
        );
    }
    if (fields[AZURE_CONNECTORS.ID] && (saveAll || selectedTab === AZURE_CONNECTORS.ID)) {
        const azureFields = fields[AZURE_CONNECTORS.ID].fields;

        if (isFieldDirty(azureFields[AZURE_AD_CONNECTOR.ID])) {
            newSettings.AADApplications = mapFieldsToAzureConnectors(azureFields);
        }

        newSettings.AADApplicationsRedirectURI = getFieldValueIfDirty(azureFields[AZURE_REDIRECT_URI.ID]);
        newSettings.AzureAdUserNamingConventions = azureFields[AZURE_AD_NAMING_CONVENTIONS.ID].value.map((nc) => ({
            conditionString: nc[CONDITION.ID].value,
            conditionType: nc[CONDITION_TYPE.ID].value
        }));
    }
    if (fields[NEW_AZURE_CONNECTORS.ID] && (saveAll || selectedTab === NEW_AZURE_CONNECTORS.ID)) {
        const azureFields = fields[NEW_AZURE_CONNECTORS.ID].fields;
        newSettings.AADConnectors = mapNewFieldsToAzureConnectors(azureFields[NEW_AZURE_AD_CONNECTOR.ID].value);
        newSettings.AzureAdUserNamingConventions = azureFields[AZURE_AD_NAMING_CONVENTIONS.ID].value.map((nc) => ({
            conditionString: nc[CONDITION.ID].value,
            conditionType: nc[CONDITION_TYPE.ID].value
        }));
    }
    if (saveAll || selectedTab === OKTA_CONNECTORS.ID) {
        const oktaFields = fields[OKTA_CONNECTORS.ID].fields;
        newSettings.OktaApplications = getFieldValueIfDirty(
            oktaFields[OKTA_BRIDGE_CONNECTOR.ID],
            mapFieldsToOktaConnectors(oktaFields)
        );
        newSettings.OktaRedirectURI = getFieldValueIfDirty(oktaFields[OKTA_REDIRECT_URI.ID]);
        newSettings.OktaBridgeEnabled = getFieldValueIfDirty(oktaFields[OKTA_BRIDGE_ENABLED.ID]);
    }

    if (saveAll || selectedTab === SSO_APPS.ID) {
        const ssoApplications = fields[SSO_APPS.ID].fields;
        const { ssoVendors } = fields[SSO_APPS.ID][SHARED_KEY];
        newSettings.SSOApplications = mapFieldsToSSOApps(ssoApplications);
        newSettings.SSOVendors = ssoVendors;
    }
    return newSettings;
};

export const mapADFSFields = (apps) => {
    const adfsFields = [];
    const { GUID_FIELD, PROTOCOL, NAME, IDENTIFIER } = ADFS_APP_FIELDS;
    for (const guid in apps) {
        const adfsApp = apps[guid];
        adfsFields.push({
            [GUID_FIELD.ID]: buildField(GUID_FIELD, guid),
            [PROTOCOL.ID]: buildField(PROTOCOL, adfsApp.protocol),
            [NAME.ID]: buildField(NAME, adfsApp.name, { required: true }),
            [IDENTIFIER.ID]: buildField(IDENTIFIER, adfsApp.identifiers, { required: true }),
            [IS_NEW_FIELD.ID]: buildField(IS_NEW_FIELD, adfsApp.isNew)
        });
    }
    return adfsFields;
};

export const mapAzureAppFields = (app) => {
    const { SAML_ENTITY_ID, LOGIN_URL, APP_NAME, SAML_CERTIFICATE, SAML_AZURE_AD_IDENTIFIER } =
        AZURE_AD_ENTERPRISE_APPLICATIONS_FIELDS;
    const appFields = {
        [SAML_ENTITY_ID.ID]: buildField(SAML_ENTITY_ID, app[SAML_ENTITY_ID.ID], { required: true }),
        [LOGIN_URL.ID]: buildField(LOGIN_URL, app[LOGIN_URL.ID], { required: true }),
        [APP_NAME.ID]: buildField(APP_NAME, app[APP_NAME.ID], { required: true }),
        [SAML_AZURE_AD_IDENTIFIER.ID]: buildField(SAML_AZURE_AD_IDENTIFIER, app[SAML_AZURE_AD_IDENTIFIER.ID], {
            required: true
        }),
        [SAML_CERTIFICATE.ID]: buildField(SAML_CERTIFICATE, app[SAML_CERTIFICATE.ID], { required: true })
    };
    return appFields;
};
export const mapNewSSOAppFields = (app, appFields) => {
    const { ID, APP_NAME, LOGIN_URL, VENDOR_ID, CERTIFICATE, ISSUER, AUDIENCE, VENDOR_NAME, LOGIN_HINT } = appFields;

    const loginHint = app[LOGIN_HINT.ID] ? { [LOGIN_HINT.ID]: buildField(LOGIN_HINT, app[LOGIN_HINT.ID]) } : {};
    return {
        ...loginHint,
        [ID.ID]: buildField(ID, app[ID.ID]),
        [AUDIENCE.ID]: buildField(AUDIENCE, app[AUDIENCE.ID], { required: true }),
        [LOGIN_URL.ID]: buildField(LOGIN_URL, app[LOGIN_URL.ID], { required: true }),
        [APP_NAME.ID]: buildField(APP_NAME, app[APP_NAME.ID], { required: true }),
        [ISSUER.ID]: buildField(ISSUER, app[ISSUER.ID], {
            required: true
        }),
        [CERTIFICATE.ID]: buildField(CERTIFICATE, app[CERTIFICATE.ID], { required: true }),
        [VENDOR_ID.ID]: buildField(VENDOR_ID, app[VENDOR_ID.ID]),
        [VENDOR_NAME.ID]: buildField(VENDOR_NAME, app[VENDOR_NAME.ID], { required: true })
    };
};

export const mapFieldsToAzureApps = (apps) => {
    const { APP_NAME, SAML_AZURE_AD_IDENTIFIER, LOGIN_URL, SAML_CERTIFICATE, SAML_ENTITY_ID } =
        AZURE_AD_ENTERPRISE_APPLICATIONS_FIELDS;
    const mappedApps = {};
    for (const app of apps) {
        mappedApps[app[SAML_ENTITY_ID.ID].value] = {
            [SAML_ENTITY_ID.ID]: app[SAML_ENTITY_ID.ID].value,
            [LOGIN_URL.ID]: app[LOGIN_URL.ID].value,
            [APP_NAME.ID]: app[APP_NAME.ID].value,
            [SAML_AZURE_AD_IDENTIFIER.ID]: app[SAML_AZURE_AD_IDENTIFIER.ID].value,
            [SAML_CERTIFICATE.ID]: app[SAML_CERTIFICATE.ID].value
        };
    }
    return mappedApps;
};

export const mapFieldsToSSOApps = (apps) => {
    const mappedApps = {};
    const { ID, APP_NAME, LOGIN_URL, VENDOR_ID, CERTIFICATE, ISSUER, AUDIENCE, SOURCE } =
        SSO_APPLICATION_FIELDS.CUSTOM_VENDOR;

    Object.entries(apps).forEach(([_, appDetails]) => {
        for (const app of appDetails.value) {
            mappedApps[app[ID.ID].value] = {
                [ID.ID]: app[ID.ID].value,
                [APP_NAME.ID]: app[APP_NAME.ID].value,
                [LOGIN_URL.ID]: app[LOGIN_URL.ID].value,
                [VENDOR_ID.ID]: app[VENDOR_ID.ID].value,
                [CERTIFICATE.ID]: app[CERTIFICATE.ID].value,
                [ISSUER.ID]: app[ISSUER.ID].value,
                [AUDIENCE.ID]: app[AUDIENCE.ID].value,
                [SOURCE.ID]: SSO_APP_SOURCE_TYPE.INTEGRATIONS
            };

            if (LOGIN_HINT_MEANINGFUL_VALUES.includes(app[SSO_APPLICATION_FIELDS.CUSTOM_VENDOR.LOGIN_HINT.ID]?.value)) {
                mappedApps[app[ID.ID].value][SSO_APPLICATION_FIELDS.CUSTOM_VENDOR.LOGIN_HINT.ID] =
                    app[SSO_APPLICATION_FIELDS.CUSTOM_VENDOR.LOGIN_HINT.ID].value;
            }
        }
    });
    return mappedApps;
};

export const mapFieldsToADFS = (adfsFields) => {
    const relyingParties = {};
    for (const adfsApp of adfsFields) {
        const { guid, protocol, name, identifier } = adfsApp;
        relyingParties[guid.value] = {
            guid: guid.value,
            protocol: protocol.value,
            name: name.value,
            identifiers: identifier.value
        };
    }
    return relyingParties;
};

export const mapPingFedFields = (apps) => {
    const adfsFields = [];
    const { GUID_FIELD, NAME, IDENTIFIER } = PINGFED_APP_FIELDS;
    for (const guid in apps) {
        const pingFedApp = apps[guid];
        adfsFields.push({
            [GUID_FIELD.ID]: buildField(GUID_FIELD, guid),
            [NAME.ID]: buildField(NAME, pingFedApp.name, { required: true }),
            [IDENTIFIER.ID]: buildField(IDENTIFIER, pingFedApp.identifiers, { required: true }),
            [IS_NEW_FIELD.ID]: buildField(IS_NEW_FIELD, pingFedApp.isNew)
        });
    }
    return adfsFields;
};

export const mapFieldsToPingFed = (pingFedFields) => {
    const relyingPartiesPingFed = {};
    for (const pingFedApp of pingFedFields) {
        const { guid, name, identifier } = pingFedApp;
        relyingPartiesPingFed[guid.value] = {
            guid: guid.value,
            name: name.value,
            identifiers: identifier.value
        };
    }
    return relyingPartiesPingFed;
};

export const mapAzureADEnterpriseApplicationsFields = (apps) => {
    const { APP_NAME, SAML_AZURE_AD_IDENTIFIER, LOGIN_URL, SAML_CERTIFICATE, SAML_ENTITY_ID } =
        AZURE_AD_ENTERPRISE_APPLICATIONS_FIELDS;
    const appsList = Object.values(apps);
    const appsFields = appsList.map((app) => ({
        [APP_NAME.ID]: buildField(APP_NAME, app[APP_NAME.ID]),
        [SAML_AZURE_AD_IDENTIFIER.ID]: buildField(SAML_AZURE_AD_IDENTIFIER, app[SAML_AZURE_AD_IDENTIFIER.ID]),
        [LOGIN_URL.ID]: buildField(LOGIN_URL, app[LOGIN_URL.ID]),
        [SAML_CERTIFICATE.ID]: buildField(SAML_CERTIFICATE, app[SAML_CERTIFICATE.ID]),
        [SAML_ENTITY_ID.ID]: buildField(SAML_ENTITY_ID, app[SAML_ENTITY_ID.ID])
    }));
    return appsFields;
};

const mapSSOApplicationsFields = (ssoVendors, apps, fields, showLoginHint = false) => {
    const { ID, APP_NAME, VENDOR_ID, VENDOR_NAME, LOGIN_URL, AUDIENCE, CERTIFICATE, ISSUER, LOGIN_HINT } = fields;
    const appsList = Object.values(apps);
    return appsList.map((app) => {
        const appFields = {
            [ID.ID]: buildField(ID, app[ID.ID]),
            [APP_NAME.ID]: buildField(APP_NAME, app[APP_NAME.ID]),
            [VENDOR_ID.ID]: buildField(VENDOR_ID, app[VENDOR_ID.ID]),
            [VENDOR_NAME.ID]: buildField(VENDOR_NAME, ssoVendors[app[VENDOR_ID.ID]]?.name || ''),
            [LOGIN_URL.ID]: buildField(LOGIN_URL, app[LOGIN_URL.ID]),
            [AUDIENCE.ID]: buildField(AUDIENCE, app[AUDIENCE.ID]),
            [CERTIFICATE.ID]: buildField(CERTIFICATE, app[CERTIFICATE.ID]),
            [ISSUER.ID]: buildField(ISSUER, app[ISSUER.ID])
        };
        if (showLoginHint) {
            appFields[LOGIN_HINT.ID] = buildField(LOGIN_HINT, app[LOGIN_HINT.ID] || 'none');
        }
        return appFields;
    });
};

export const mapAzureADConnectorFields = (adConnectors, type, wizard = false) => {
    const {
        APPLICATION_ID,
        CLIENT_SECRET,
        TENANT_ID,
        ACCESS_TOKEN,
        REFRESH_TOKEN,
        AUTHORIZED,
        HAS_CLIENT_SECRET,
        TYPE
    } = AZURE_CONNECTOR_FIELDS;
    const adConnectorsFields = [];
    for (const adConnector of adConnectors) {
        if (adConnector.type !== type) {
            continue;
        }
        const applicationIdField = buildField(APPLICATION_ID, adConnector.applicationID, {}, {}, false);
        let searchByTenantOnly = true;
        if (type === AD_CONNECTOR_TYPE.APPLICATION) {
            applicationIdField.validators = { required: true };
            applicationIdField.searchable = true;
            searchByTenantOnly = false;
        }
        adConnectorsFields.push({
            [APPLICATION_ID.ID]: applicationIdField,
            [CLIENT_SECRET.ID]: buildField(CLIENT_SECRET, adConnector.clientSecret || '', {}, {}, !searchByTenantOnly),
            [ACCESS_TOKEN.ID]: buildField(ACCESS_TOKEN, '', {}, { saveNeeded: !wizard, wizardSaveNeeded: wizard }),
            [REFRESH_TOKEN.ID]: buildField(REFRESH_TOKEN, ''),
            [TENANT_ID.ID]: buildField(TENANT_ID, adConnector.tenantID, {}, {}, searchByTenantOnly),
            [HAS_CLIENT_SECRET.ID]: buildField(HAS_CLIENT_SECRET, adConnector.hasClientSecret),
            [AUTHORIZED.ID]: buildField(AUTHORIZED, adConnector.authorized),
            [TYPE.ID]: buildField(TYPE, adConnector.type),
            [IS_NEW_FIELD.ID]: buildField(IS_NEW_FIELD, adConnector.isNew)
        });
    }
    return adConnectorsFields;
};

export const mapFieldsToAzureConnectors = (azureFields) => {
    const {
        APPLICATION_ID,
        CLIENT_SECRET,
        TENANT_ID,
        ACCESS_TOKEN,
        REFRESH_TOKEN,
        AUTHORIZED,
        HAS_CLIENT_SECRET,
        TYPE
    } = AZURE_CONNECTOR_FIELDS;
    const aadApplications = [];
    const azureApps = azureFields[AZURE_AD_CONNECTOR.ID].value;
    for (const azureApp of azureApps) {
        aadApplications.push({
            applicationID: azureApp[APPLICATION_ID.ID].value,
            clientSecret: azureApp[CLIENT_SECRET.ID].value,
            accessToken: azureApp[ACCESS_TOKEN.ID].value,
            refreshToken: azureApp[REFRESH_TOKEN.ID].value,
            tenantID: azureApp[TENANT_ID.ID].value,
            hasClientSecret: azureApp[HAS_CLIENT_SECRET.ID].value,
            authorized: azureApp[AUTHORIZED.ID].value,
            type: azureApp[TYPE.ID].value
        });
    }
    return aadApplications;
};

export const mapOktaConnectorFields = (oktaConnectors, wizard = false) => {
    const { OKTA_DOMAIN, CLIENT_ID, CLIENT_SECRET, ACCESS_TOKEN, REFRESH_TOKEN, AUTHORIZED, HAS_CLIENT_SECRET } =
        OKTA_CONNECTOR_FIELDS;
    const oktaConnectorsFields = [];
    for (const oktaConnector of oktaConnectors) {
        oktaConnectorsFields.push({
            [OKTA_DOMAIN.ID]: buildField(OKTA_DOMAIN, oktaConnector.oktaDomain),
            [CLIENT_ID.ID]: buildField(CLIENT_ID, oktaConnector.clientId),
            [CLIENT_SECRET.ID]: buildField(CLIENT_SECRET, oktaConnector.clientSecret),
            [ACCESS_TOKEN.ID]: buildField(ACCESS_TOKEN, '', {}, { saveNeeded: !wizard, wizardSaveNeeded: wizard }),
            [REFRESH_TOKEN.ID]: buildField(REFRESH_TOKEN, ''),
            [HAS_CLIENT_SECRET.ID]: buildField(HAS_CLIENT_SECRET, oktaConnector.hasClientSecret),
            [AUTHORIZED.ID]: buildField(AUTHORIZED, oktaConnector.authorized)
        });
    }
    if (oktaConnectorsFields.length === 0) {
        oktaConnectorsFields.push({
            [OKTA_DOMAIN.ID]: buildField(OKTA_DOMAIN, ''),
            [CLIENT_ID.ID]: buildField(CLIENT_ID, ''),
            [CLIENT_SECRET.ID]: buildField(CLIENT_SECRET, ''),
            [ACCESS_TOKEN.ID]: buildField(ACCESS_TOKEN, '', {}, { saveNeeded: !wizard, wizardSaveNeeded: wizard }),
            [REFRESH_TOKEN.ID]: buildField(REFRESH_TOKEN, ''),
            [HAS_CLIENT_SECRET.ID]: buildField(HAS_CLIENT_SECRET, false),
            [AUTHORIZED.ID]: buildField(AUTHORIZED, false)
        });
    }
    return oktaConnectorsFields;
};

export const mapFieldsToOktaConnectors = (oktaFields) => {
    const { OKTA_DOMAIN, CLIENT_ID, CLIENT_SECRET, ACCESS_TOKEN, REFRESH_TOKEN, AUTHORIZED, HAS_CLIENT_SECRET } =
        OKTA_CONNECTOR_FIELDS;
    const oktaApplications = [];
    for (const oktaApp of oktaFields[OKTA_BRIDGE_CONNECTOR.ID].value) {
        if (oktaApp[OKTA_DOMAIN.ID].value || oktaApp[CLIENT_ID.ID].value || oktaApp[CLIENT_SECRET.ID].value) {
            oktaApplications.push({
                oktaDomain: oktaApp[OKTA_DOMAIN.ID].value,
                clientId: oktaApp[CLIENT_ID.ID].value,
                clientSecret: oktaApp[CLIENT_SECRET.ID].value,
                accessToken: oktaApp[ACCESS_TOKEN.ID].value,
                refreshToken: oktaApp[REFRESH_TOKEN.ID].value,
                hasClientSecret: oktaApp[HAS_CLIENT_SECRET.ID].value,
                authorized: oktaApp[AUTHORIZED.ID].value
            });
        }
    }
    return oktaApplications;
};

export const addMultipleAppsAction = (state, action, tabKey, fieldId, fieldsMapperFunc) => {
    const existingApps = state[tabKey].fields[fieldId].value;
    const existingMap = new Map();
    for (const app of existingApps) {
        existingMap.set(app.name.value, app.identifier.value);
    }
    let newState = { ...state };
    for (const addedApp of action.payload) {
        const alreadyExists = existingMap.get(addedApp.name);
        if (alreadyExists && alreadyExists === addedApp.identifiers) {
            continue;
        }
        const guid = uuidv4();
        const appFields = {
            [guid]: {
                guid: guid,
                name: addedApp.name,
                identifiers: addedApp.identifiers,
                isNew: true
            }
        };
        if (addedApp.protocol) {
            appFields[guid].protocol = addedApp.protocol;
        }
        const newApp = fieldsMapperFunc(appFields);
        newState = addFieldsToArray(newState, tabKey, fieldId, newApp[0]);
    }
    return newState;
};

export const newAzureApp = () => {
    const newAzureApp = mapAzureADConnectorFields(
        [
            {
                applicationID: '',
                clientSecret: '',
                accessToken: '',
                refreshToken: '',
                tenantID: '',
                hasClientSecret: false,
                authorized: false,
                type: AD_CONNECTOR_TYPE.APPLICATION,
                isNew: true
            }
        ],
        AD_CONNECTOR_TYPE.APPLICATION
    );
    return newAzureApp[0];
};

export const newAzureConnector = () => {
    const newAzureApp = mapNewAzureADConnectorFields([
        {
            tenantId: '',
            tenantName: '',
            clientId: '',
            clientSecret: '',
            hasClientSecret: false,
            roles: []
        }
    ]);
    return newAzureApp[0];
};

export const newPingFedApp = () => {
    const pingFedGuid = uuidv4();
    const newPingFedApp = mapPingFedFields({
        [pingFedGuid]: {
            guid: pingFedGuid,
            name: '',
            identifiers: '',
            isNew: true
        }
    });
    return newPingFedApp[0];
};

export const newADFSApp = () => {
    const guid = uuidv4();
    const newADFSApp = mapADFSFields({
        [guid]: {
            guid: guid,
            protocol: 'SAML',
            name: '',
            identifiers: '',
            isNew: true
        }
    });
    return newADFSApp[0];
};

export const newAzureEnterpriseApp = () => {
    const { APP_NAME, SAML_AZURE_AD_IDENTIFIER, LOGIN_URL, SAML_CERTIFICATE, SAML_ENTITY_ID } =
        AZURE_AD_ENTERPRISE_APPLICATIONS_FIELDS;
    const newAzureEnterpriseApp = mapAzureAppFields({
        [APP_NAME.ID]: '',
        [SAML_AZURE_AD_IDENTIFIER.ID]: '',
        [LOGIN_URL.ID]: '',
        [SAML_ENTITY_ID.ID]: '',
        [SAML_CERTIFICATE.ID]: null
    });
    return newAzureEnterpriseApp;
};

export const newSSOApp = (vendorId, vendorName, showLoginHint = false) => {
    const { ID, APP_NAME, LOGIN_URL, VENDOR_ID, VENDOR_NAME, CERTIFICATE, ISSUER, AUDIENCE, LOGIN_HINT } =
        SSO_APPLICATION_FIELDS.CUSTOM_VENDOR;
    const loginHint = showLoginHint ? { [LOGIN_HINT.ID]: 'none' } : {};
    return mapNewSSOAppFields(
        {
            ...loginHint,
            [ID.ID]: uuidv4(),
            [APP_NAME.ID]: '',
            [LOGIN_URL.ID]: '',
            [ISSUER.ID]: '',
            [AUDIENCE.ID]: '',
            [CERTIFICATE.ID]: null,
            [VENDOR_ID.ID]: vendorId,
            [VENDOR_NAME.ID]: vendorName
        },
        SSO_APPLICATION_FIELDS.CUSTOM_VENDOR
    );
};

export const newSSOOktaApp = (showLoginHint = false) => {
    const { ID, APP_NAME, VENDOR_ID, VENDOR_NAME, LOGIN_URL, CERTIFICATE, ISSUER, AUDIENCE, LOGIN_HINT } =
        SSO_APPLICATION_FIELDS.OKTA;
    const loginHint = showLoginHint ? { [LOGIN_HINT.ID]: 'none' } : {};
    return mapNewSSOAppFields(
        {
            ...loginHint,
            [ID.ID]: uuidv4(),
            [APP_NAME.ID]: '',
            [LOGIN_URL.ID]: '',
            [ISSUER.ID]: '',
            [AUDIENCE.ID]: '',
            [CERTIFICATE.ID]: null,
            [VENDOR_ID.ID]: 2,
            [VENDOR_NAME.ID]: OKTA.NAME
        },
        SSO_APPLICATION_FIELDS.OKTA
    );
};

export const newSSOEntraIdApp = (showLoginHint = false) => {
    const { ID, APP_NAME, VENDOR_ID, LOGIN_URL, CERTIFICATE, ISSUER, AUDIENCE, VENDOR_NAME, LOGIN_HINT } =
        SSO_APPLICATION_FIELDS.ENTRA_ID;
    const loginHint = showLoginHint ? { [LOGIN_HINT.ID]: 'none' } : {};
    return mapNewSSOAppFields(
        {
            ...loginHint,
            [ID.ID]: uuidv4(),
            [APP_NAME.ID]: '',
            [LOGIN_URL.ID]: '',
            [ISSUER.ID]: '',
            [AUDIENCE.ID]: '',
            [CERTIFICATE.ID]: null,
            [VENDOR_ID.ID]: 1,
            [VENDOR_NAME.ID]: ENTRA_ID.NAME
        },
        SSO_APPLICATION_FIELDS.ENTRA_ID
    );
};

export const newSSOPingFederateApp = (showLoginHint = false) => {
    const { ID, APP_NAME, VENDOR_ID, LOGIN_URL, CERTIFICATE, ISSUER, AUDIENCE, VENDOR_NAME, LOGIN_HINT } =
        SSO_APPLICATION_FIELDS.PING_FEDERATE;
    const loginHint = showLoginHint ? { [LOGIN_HINT.ID]: 'none' } : {};
    return mapNewSSOAppFields(
        {
            ...loginHint,
            [ID.ID]: uuidv4(),
            [APP_NAME.ID]: '',
            [LOGIN_URL.ID]: '',
            [ISSUER.ID]: '',
            [AUDIENCE.ID]: '',
            [CERTIFICATE.ID]: null,
            [VENDOR_ID.ID]: 3,
            [VENDOR_NAME.ID]: PING_FEDERATE.NAME
        },
        SSO_APPLICATION_FIELDS.PING_FEDERATE
    );
};

export const newSSOOneLoginApp = (showLoginHint = false) => {
    const { ID, APP_NAME, VENDOR_ID, LOGIN_URL, CERTIFICATE, ISSUER, AUDIENCE, VENDOR_NAME, LOGIN_HINT } =
        SSO_APPLICATION_FIELDS.ONE_LOGIN;
    const loginHint = showLoginHint ? { [LOGIN_HINT.ID]: 'none' } : {};
    return mapNewSSOAppFields(
        {
            ...loginHint,
            [ID.ID]: uuidv4(),
            [APP_NAME.ID]: '',
            [LOGIN_URL.ID]: '',
            [ISSUER.ID]: '',
            [AUDIENCE.ID]: '',
            [CERTIFICATE.ID]: null,
            [VENDOR_ID.ID]: 4,
            [VENDOR_NAME.ID]: ONE_LOGIN.NAME
        },
        SSO_APPLICATION_FIELDS.ONE_LOGIN
    );
};

export const newSSOCyberArkApp = (showLoginHint = false) => {
    const { ID, APP_NAME, VENDOR_ID, LOGIN_URL, CERTIFICATE, ISSUER, AUDIENCE, VENDOR_NAME, LOGIN_HINT } =
        SSO_APPLICATION_FIELDS.CYBER_ARK;
    const loginHint = showLoginHint ? { [LOGIN_HINT.ID]: 'none' } : {};
    return mapNewSSOAppFields(
        {
            ...loginHint,
            [ID.ID]: uuidv4(),
            [APP_NAME.ID]: '',
            [LOGIN_URL.ID]: '',
            [ISSUER.ID]: '',
            [AUDIENCE.ID]: '',
            [CERTIFICATE.ID]: null,
            [VENDOR_ID.ID]: 5,
            [VENDOR_NAME.ID]: CYBER_ARK.NAME
        },
        SSO_APPLICATION_FIELDS.CYBER_ARK
    );
};

export const newSSOThalesSTAApp = (showLoginHint = false) => {
    const { ID, APP_NAME, VENDOR_ID, LOGIN_URL, CERTIFICATE, ISSUER, AUDIENCE, VENDOR_NAME, LOGIN_HINT } =
        SSO_APPLICATION_FIELDS.THALES_STA;
    const loginHint = showLoginHint ? { [LOGIN_HINT.ID]: 'none' } : {};
    return mapNewSSOAppFields(
        {
            ...loginHint,
            [ID.ID]: uuidv4(),
            [APP_NAME.ID]: '',
            [LOGIN_URL.ID]: '',
            [ISSUER.ID]: '',
            [AUDIENCE.ID]: '',
            [CERTIFICATE.ID]: null,
            [VENDOR_ID.ID]: 6,
            [VENDOR_NAME.ID]: THALES_STA.NAME
        },
        SSO_APPLICATION_FIELDS.THALES_STA
    );
};

export const newSSOBeyondIdentityApp = (showLoginHint = false) => {
    const { ID, APP_NAME, VENDOR_ID, LOGIN_URL, CERTIFICATE, ISSUER, AUDIENCE, VENDOR_NAME, LOGIN_HINT } =
        SSO_APPLICATION_FIELDS.BEYOND_IDENTITY;
    const loginHint = showLoginHint ? { [LOGIN_HINT.ID]: 'none' } : {};
    return mapNewSSOAppFields(
        {
            ...loginHint,
            [ID.ID]: uuidv4(),
            [APP_NAME.ID]: '',
            [LOGIN_URL.ID]: '',
            [ISSUER.ID]: '',
            [AUDIENCE.ID]: '',
            [CERTIFICATE.ID]: null,
            [VENDOR_ID.ID]: 7,
            [VENDOR_NAME.ID]: BEYOND_IDENTITY.NAME
        },
        SSO_APPLICATION_FIELDS.BEYOND_IDENTITY
    );
};

export const mapNewAzureADConnectorFields = (aadConnectors) => {
    const { TENANT_ID, TENANT_NAME, CLIENT_ID, CLIENT_SECRET, HAS_CLIENT_SECRET, ROLES } = NEW_AZURE_CONNECTOR_FIELDS;
    const aadConnectorsFields = [];
    for (const aadConnector of aadConnectors) {
        aadConnectorsFields.push({
            [TENANT_ID.ID]: buildField(TENANT_ID, aadConnector.tenantId, {
                required: true,
                notContainWhitespace: true
            }),
            [TENANT_NAME.ID]: buildField(TENANT_NAME, aadConnector.tenantName, { required: true }),
            [CLIENT_ID.ID]: buildField(CLIENT_ID, aadConnector.clientId, { required: true }),
            [CLIENT_SECRET.ID]: buildField(
                CLIENT_SECRET,
                aadConnector.clientSecret,
                aadConnector.hasClientSecret ? {} : { required: true }
            ),
            [HAS_CLIENT_SECRET.ID]: buildField(HAS_CLIENT_SECRET, aadConnector.hasClientSecret),
            [ROLES.ID]: buildField(ROLES, aadConnector.roles)
        });
    }

    return aadConnectorsFields;
};

export const mapNewFieldsToAzureConnectors = (azureFields) => {
    const { TENANT_ID, TENANT_NAME, CLIENT_ID, CLIENT_SECRET, ROLES } = NEW_AZURE_CONNECTOR_FIELDS;
    const aadConnectors = [];
    for (const connectorFields of azureFields) {
        aadConnectors.push({
            tenantId: connectorFields[TENANT_ID.ID].value,
            tenantName: connectorFields[TENANT_NAME.ID].value,
            clientId: connectorFields[CLIENT_ID.ID].value,
            clientSecret: connectorFields[CLIENT_SECRET.ID].value,
            hasClientSecret: true,
            roles: connectorFields[ROLES.ID].value
        });
    }
    return aadConnectors;
};

function mapNamingConventions(conditions, isNew) {
    if (conditions) {
        return conditions.map((condition) => {
            return {
                [CONDITION.ID]: buildField(CONDITION, condition.conditionString, {
                    required: true,
                    minLength: 1,
                    noSemicolon: true
                }),
                [CONDITION_TYPE.ID]: buildField(CONDITION_TYPE, condition.conditionType),
                [IS_NEW_FIELD.ID]: buildField(IS_NEW_FIELD, isNew)
            };
        });
    }
    return [];
}
